import { useLoaderData } from "react-router";
import CustomError from "@components/Error/CustomError";
import { MetaTagDescriptor } from "@components/MetaTags/MetaTags";
import { Route } from "@route-types/Newsletter/SignUp/+types/NewsletterSignUpPage";
import { fetchNewsletterSignUpPageData } from "@routes/Newsletter/SignUp/NewsletterSignUpPage.server";
import NewsletterSignUpPageContent from "@routes/Newsletter/SignUp/NewsletterSignUpPageContent";
import { NewsletterSignUpPageContext } from "@routes/Newsletter/SignUp/utils/types";
import { ResponseType } from "@sphtech/web2-core/ssr";
import { HttpStatusCode } from "axios";

/** This is the main entry point component for /newsletter-signup route. */
const NewsletterSignUpPage = (): React.ReactElement => {
  const context = useLoaderData<NewsletterSignUpPageContext>();

  // StatusCode is not 200
  if (context && context.statusCode !== HttpStatusCode.Ok) {
    return <CustomError statusCode={context.statusCode} />;
  }

  // Check if payload is missing
  if (typeof context?.payload === "undefined") {
    return <CustomError statusCode={HttpStatusCode.NotFound} />;
  }

  return <NewsletterSignUpPageContent {...context.payload.data} />;
};

export default NewsletterSignUpPage;

export const loader = async () => await fetchNewsletterSignUpPageData();

export const meta = ({ loaderData }: Route.MetaArgs): MetaTagDescriptor[] => {
  const context = loaderData as NewsletterSignUpPageContext;

  if (context.type !== ResponseType.SUCCESS) return [];

  const data = context.payload;

  if (!data) return [];
  if (!data.metaTags) return [];

  return data.metaTags;
};
